// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"SupplierWiseAPIPurchasePage_inputContainer__1bIHg"};